import { instance as axios } from '../../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { Plans , VestingSchedule , SaveGrant , 
    Grantnos , GetGrantInfo , SaveMaintainGrant , UploadProfile , 
    SendGrantInfo , GrantListInfo , GetOfferGrantInfo , UserDetails , 
    PrevEmailInfo , ManualAcceptanceUserDetails } from '../../../models/esopCreateGrant';

//================|| CREATE GRANT SLICE ||=================//

type CreateGHrantState = {
    loading: boolean;
    error: ErrorInformation,
    plans: Plans[];
    vestingSchedule: VestingSchedule[];
    grantnos: Grantnos[];
    getGrantInfo: GetGrantInfo[];
    SaveResponse: string;
    uploadProfile: UploadProfile | null;
    sendGrantInfo: SendGrantInfo[];
    grantListInfo: GrantListInfo[];
    getOfferGrantInfo: GetOfferGrantInfo[];
    userDetails: UserDetails[];
    EmailResponse: string;
    prevEmailInfo: PrevEmailInfo[];
    manualAcceptanceUserDetails: ManualAcceptanceUserDetails[];
}

type GrantInfo = {
    plans: Plans[];
    vestingSchedule: VestingSchedule[];
}

type fromtoStatusID = {
    fromStatusID: number,
    toStatusID: number,
}
type uploadfile = {
    sourcePath: File,
    grantno: string
}
type getfile = {
    csvtype: string,
    grantno: string
}
const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
};

type SupervisorApprove = {
    grantno: string,
    verifyStatus: string,
}

type userNameanduserID = {
    searchUserID: string,
    searchName: string,
}

type GrantNoandofferID = {
    grantNo: string,
    offerID: number,
    isEntireGrant: boolean,
}

type PostOfferParams = {
    grantNo: string,
    offerID: number,
    emailSubject: string,
    emailBody: string,
}

type PostManualAcceptance = {
    offerID: number,
    acceptanceDate: string,
}

const initialState: CreateGHrantState = {
    loading: true,
    error: null,
    plans: [],
    vestingSchedule: [],
    grantnos:[],
    getGrantInfo: [],
    SaveResponse: '',
    uploadProfile: null,
    sendGrantInfo: [],
    grantListInfo: [],
    getOfferGrantInfo: [],
    userDetails: [],
    EmailResponse: '',
    prevEmailInfo: [],
    manualAcceptanceUserDetails: [],
};

export const getGrantDetails = createAsyncThunk<GrantInfo, {}, { rejectValue: ErrorInformation }>(
    "creategrant/getGrantDetails",
    async ({ }, { rejectWithValue }) => {
        try {
            const palnResponse = await axios.get<Plans[]>('/Grant/getCurrentPlan');
            const vestingResponse = await axios.get<VestingSchedule[]>('/Grant/getVestingSchedule');
            return {
                plans: palnResponse.data,
                vestingSchedule: vestingResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setNewGrant = createAsyncThunk<number, { grantInfo: SaveGrant }, { rejectValue: ErrorInformation }>(
    "creategrant/setNewGrant",
    async ({grantInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/Grant/setNewGrant', grantInfo)
            return response.data[0];
           
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getGrantNo = createAsyncThunk(
    "creategrant/getGrantNo",
    async (fromtoStatusID: fromtoStatusID, { rejectWithValue }) => {
        try {
            const getGrantNoResponse = await axios.get<Grantnos>(`Grant/getGrantNo?fromStatusID=${fromtoStatusID.fromStatusID}&toStatusID=${fromtoStatusID.toStatusID}`)
            return getGrantNoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getGrantDetailsforMaintainGrant = createAsyncThunk(
    "profile/getGrantDetailsforMaintainGrant",
    async (grantNo: string, { rejectWithValue }) => {
        try {
            const getGrantDetailsforMaintainGrantResponse = await axios.get<GetGrantInfo>(`Grant/getGrantDetails?grantNo=${grantNo}`)
            return getGrantDetailsforMaintainGrantResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setMaintainGrant = createAsyncThunk<number, { grantInfo: SaveMaintainGrant }, { rejectValue: ErrorInformation }>(
    "creategrant/setMaintainGrant",
    async ({grantInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.put('/Grant/setMaintainGrant', grantInfo)
            return response.data[0];
           
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setUploadGrantList = createAsyncThunk(
    "creategrant/setUploadGrantList",
    async (uploadfile: uploadfile, { rejectWithValue }) => {
        try {
            const optionpostUploadGrant = await axios.post<UploadProfile>(`Grant/setUploadGrantList?grantNo=${uploadfile.grantno}`,{
                sourcePath: uploadfile.sourcePath
            }, config);
            return optionpostUploadGrant.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getUploadGrantList = createAsyncThunk(
    "creategrant/getUploadGrantList",
    async (getfile: getfile, { rejectWithValue }) => {
        try {
            const getUploadUserProfileResponse = await axios.get<string>(`Grant/getUploadGrantList?type=${getfile.csvtype}&grantNo=${getfile.grantno}`)
            return getUploadUserProfileResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getSendGrantForApproval = createAsyncThunk<SendGrantInfo, {}, { rejectValue: ErrorInformation }>(
    "creategrant/getSendGrantForApproval",
    async ({ }, { rejectWithValue }) => {
        try {
            const getSendGrantForApprovalResponse = await axios.get<SendGrantInfo>('Grant/getSendGrantForApproval')
            return getSendGrantForApprovalResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getGrantList = createAsyncThunk(
    "creategrant/getGrantList",
    async (grantNo: string, { rejectWithValue }) => {
        try {
            const getGrantListResponse = await axios.get<GrantListInfo>(`Grant/getGrantList?grantNo=${grantNo}`)
            return getGrantListResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const SetSendGrantForApproval = createAsyncThunk(
    "creategrant/SetSendGrantForApproval",
    async (grantNo: string, { rejectWithValue }) => {
        try {
            const SetSendGrantForApprovalResponse = await axios.post<string>(`Grant/SetSendGrantForApproval?grantNo=${grantNo}`)
            return SetSendGrantForApprovalResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getApproveGrant = createAsyncThunk<SendGrantInfo, {}, { rejectValue: ErrorInformation }>(
    "creategrant/getApproveGrant",
    async ({ }, { rejectWithValue }) => {
        try {
            const getApproveGrantResponse = await axios.get<SendGrantInfo>('Grant/getApproveGrant')
            return getApproveGrantResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const SetApproveGrant = createAsyncThunk(
    "creategrant/SetApproveGrant",
    async (supervisorApprove: SupervisorApprove, { rejectWithValue }) => {
        try {
            const SetApproveGrantResponse = await axios.post<string>(`Grant/SetApproveGrant?grantNo=${supervisorApprove.grantno}&verifyStatus=${supervisorApprove.verifyStatus}`)
            return SetApproveGrantResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getGenerateOfferLetter = createAsyncThunk<GetOfferGrantInfo, {}, { rejectValue: ErrorInformation }>(
    "creategrant/getGenerateOfferLetter",
    async ({ }, { rejectWithValue }) => {
        try {
            const getGenerateOfferLetterResponse = await axios.get<GetOfferGrantInfo>('Grant/getGenerateOfferLetter')
            return getGenerateOfferLetterResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getOfferLetterSearch = createAsyncThunk(
    "profile/getOfferLetterSearch",
    async (userNameanduserID: userNameanduserID, { rejectWithValue }) => {
        try {
            if(userNameanduserID.searchUserID.toString() != '' && 
            userNameanduserID.searchName.toString() != '') {
                const getOfferLetterSearchResponse = await axios.get<UserDetails[]>(`Grant/getOfferLetterSearch?searchUserID=${userNameanduserID.searchUserID.toString()}&searchName=${userNameanduserID.searchName.toString()}`)
                return getOfferLetterSearchResponse.data
            }
            else if(userNameanduserID.searchUserID.toString() != '') {
                const getOfferLetterSearchResponse = await axios.get<UserDetails[]>(`Grant/getOfferLetterSearch?searchUserID=${userNameanduserID.searchUserID.toString()}`)
                return getOfferLetterSearchResponse.data
            }
            else if(userNameanduserID.searchName.toString() != '') {
                const getOfferLetterSearchResponse = await axios.get<UserDetails[]>(`Grant/getOfferLetterSearch?searchName=${userNameanduserID.searchName.toString()}`)
                return getOfferLetterSearchResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getGenerateOfferLetterPreviewInfo = createAsyncThunk(
    "creategrant/getGenerateOfferLetterPreviewInfo",
    async (grantNoandofferID: GrantNoandofferID, { rejectWithValue }) => {
        try {
            const getGenerateOfferLetterPreviewInfoResponse = await axios.get<PrevEmailInfo[]>(`Grant/getGenerateOfferLetterPreviewInfo?grantNo=${grantNoandofferID.grantNo}&offerID=${grantNoandofferID.offerID}&isEntireGrant=${grantNoandofferID.isEntireGrant}`)
            return getGenerateOfferLetterPreviewInfoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const SetGenerateOfferLetter = createAsyncThunk(
    "creategrant/SetGenerateOfferLetter",
    async (postOfferParams: PostOfferParams, { rejectWithValue }) => {
        try {
            const SetGenerateOfferLetterResponse = await axios.post<string>(`Grant/SetGenerateOfferLetter?grantNo=${postOfferParams.grantNo}&offerID=${postOfferParams.offerID}&emailSubject=${postOfferParams.emailSubject}&emailBody=${postOfferParams.emailBody}`)
            return SetGenerateOfferLetterResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getManualAcceptance = createAsyncThunk(
    "profile/getManualAcceptance",
    async (userNameanduserID: userNameanduserID, { rejectWithValue }) => {
        try {
            if(userNameanduserID.searchUserID.toString() != '' && 
            userNameanduserID.searchName.toString() != '') {
                const getManualAcceptanceResponse = await axios.get<ManualAcceptanceUserDetails[]>(`Grant/getManualAcceptance?searchUserID=${userNameanduserID.searchUserID.toString()}&searchName=${userNameanduserID.searchName.toString()}`)
                return getManualAcceptanceResponse.data
            }
            else if(userNameanduserID.searchUserID.toString() != '') {
                const getManualAcceptanceResponse = await axios.get<ManualAcceptanceUserDetails[]>(`Grant/getManualAcceptance?searchUserID=${userNameanduserID.searchUserID.toString()}`)
                return getManualAcceptanceResponse.data
            }
            else if(userNameanduserID.searchName.toString() != '') {
                const getManualAcceptanceResponse = await axios.get<ManualAcceptanceUserDetails[]>(`Grant/getManualAcceptance?searchName=${userNameanduserID.searchName.toString()}`)
                return getManualAcceptanceResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setManualAcceptance = createAsyncThunk(
    "creategrant/setManualAcceptance",
    async (postManualAcceptance: PostManualAcceptance, { rejectWithValue }) => {
        try {
            const setManualAcceptanceResponse = await axios.post<string>(`Grant/setManualAcceptance?offerID=${postManualAcceptance.offerID}&acceptanceDate=${postManualAcceptance.acceptanceDate}`)
            return setManualAcceptanceResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

const createGrantSlice = createSlice({
    name: 'creategrant',
    initialState,
    reducers: {},
    extraReducers: {
        //get Plan and Vesting deatils
        [getGrantDetails.pending.type]: (state) => {
            state.loading = true;
        },
        [getGrantDetails.fulfilled.type]: (state, action) => {
            const { plans, vestingSchedule } = action.payload
            state.vestingSchedule = vestingSchedule;
            state.plans = plans;
            state.loading = false;
        },
        [getGrantDetails.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Save Create Grant
        [setNewGrant.pending.type]: (state) => {
            state.loading = true;
        },
        [setNewGrant.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setNewGrant.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Grant No for Maintain Grant
        [getGrantNo.pending.type]: (state) => {
            state.loading = true;
        },
        [getGrantNo.fulfilled.type]: (state, action) => {
            state.grantnos = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getGrantNo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //get Grant Details against Grant No. for Maintain Grant
        [getGrantDetailsforMaintainGrant.pending.type]: (state) => {
            state.loading = true;
        },
        [getGrantDetailsforMaintainGrant.fulfilled.type]: (state, action) => {
            state.getGrantInfo = action.payload;
            state.loading = false;
        },
        [getGrantDetailsforMaintainGrant.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Update Maintain Grant
        [setMaintainGrant.pending.type]: (state) => {
            state.loading = true;
        },
        [setMaintainGrant.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setMaintainGrant.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Upload Grant
        [setUploadGrantList.pending.type]: (state) => {
            state.loading = true;
        },
        [setUploadGrantList.fulfilled.type]: (state, action) => {
            state.uploadProfile = action.payload;
            state.loading = false;
            state.error = null;
        },
        [setUploadGrantList.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Upload Grant List
        [getUploadGrantList.pending.type]: (state) => {
            state.loading = true;
        },
        [getUploadGrantList.fulfilled.type]: (state) => {
            state.loading = false;
            state.error = null;
        },
        [getUploadGrantList.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Send Grant For Approval
        [getSendGrantForApproval.pending.type]: (state) => {
            state.loading = true;
        },
        [getSendGrantForApproval.fulfilled.type]: (state, action) => {
            state.sendGrantInfo = action.payload;
            state.loading = false;
        },
        [getSendGrantForApproval.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //get View Grant List
        [getGrantList.pending.type]: (state) => {
            state.loading = true;
        },
        [getGrantList.fulfilled.type]: (state, action) => {
            state.grantListInfo = action.payload;
            state.loading = false;
        },
        [getGrantList.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Send Grant For Approval
        [SetSendGrantForApproval.pending.type]: (state) => {
            state.loading = true;
        },
        [SetSendGrantForApproval.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [SetSendGrantForApproval.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //get Supervisor Grant For Approval
        [getApproveGrant.pending.type]: (state) => {
            state.loading = true;
        },
        [getApproveGrant.fulfilled.type]: (state, action) => {
            state.sendGrantInfo = action.payload;
            state.loading = false;
        },
        [getApproveGrant.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Post Supervisor Grant For Approval
        [SetApproveGrant.pending.type]: (state) => {
            state.loading = true;
        },
        [SetApproveGrant.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [SetApproveGrant.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Generate Letter Grant Info
        [getGenerateOfferLetter.pending.type]: (state) => {
            state.loading = true;
        },
        [getGenerateOfferLetter.fulfilled.type]: (state, action) => {
            state.getOfferGrantInfo = action.payload;
            state.loading = false;
        },
        [getGenerateOfferLetter.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        //Generate Offer get User List View
        [getOfferLetterSearch.pending.type]: (state) => {
            state.loading = true;
        },
        [getOfferLetterSearch.fulfilled.type]: (state, action) => {
            state.userDetails = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getOfferLetterSearch.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        // Generate Offer Leter Preview Email
        [getGenerateOfferLetterPreviewInfo.pending.type]: (state) => {
            state.loading = true;
        },
        [getGenerateOfferLetterPreviewInfo.fulfilled.type]: (state, action) => {
            state.prevEmailInfo = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getGenerateOfferLetterPreviewInfo.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Send Mail for Generate Offer Letter
        [SetGenerateOfferLetter.pending.type]: (state) => {
            state.loading = true;
        },
        [SetGenerateOfferLetter.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [SetGenerateOfferLetter.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Manual Acceptance get User List View
        [getManualAcceptance.pending.type]: (state) => {
            state.loading = true;
        },
        [getManualAcceptance.fulfilled.type]: (state, action) => {
            state.manualAcceptanceUserDetails = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getManualAcceptance.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Manual Acceptance Save
        [setManualAcceptance.pending.type]: (state) => {
            state.loading = true;
        },
        [setManualAcceptance.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setManualAcceptance.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

    }
})

export default createGrantSlice